// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2G7zy","list":"BalanceDue_list__1e2Re","listRow":"BalanceDue_listRow__1_v-0","total":"BalanceDue_total__3XJKu"};